import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const useStoreLocatorStyles = makeStyles({
    root: {},
    contentWrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'end',
        columnGap: tokens.spacingHorizontalL,
        ...shorthands.padding(tokens.spacingVerticalS),
        paddingTop: '0',
        '@media screen and (max-width: 480px)': {
            flexDirection: 'column',
            width: '100%'
        }
    },
    inputWrapper: {
        width: '80%',
        '@media screen and (max-width: 480px)': {
            display: 'flex',
            width: '100%'
        }
    },
    buttonWrapper: {
        marginBottom: tokens.spacingHorizontalXS,
        width: '20%',
        '@media screen and (max-width: 480px)': {
            display: 'flex',
            width: '100%'
        }
    },
    searchResults: {
        '@media screen and (max-width: 480px)': {
            display: 'flex',
            width: '100%'
        }
    },
    searchResultsWrapper: {
        ...shorthands.padding(
            tokens.spacingVerticalS,
            '0',
            tokens.spacingVerticalS,
            tokens.spacingVerticalS
        )
    },
    resultCardRoot: {
        maxWidth: '275px',
        ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke2),
        ...shorthands.borderRadius('16px'),
        '@media screen and (max-width: 480px)': {
            display: 'flex',
            width: '100%'
        }
    },
    selectedResultCard: {
        maxWidth: '275px',
        ...shorthands.border('1px', 'solid', tokens.colorBrandForeground1),
        ...shorthands.borderRadius('16px'),
        '@media screen and (max-width: 480px)': {
            display: 'flex',
            width: '100%'
        }
    },
    resultGroup: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        rowGap: tokens.spacingVerticalXL,
        columnGap: tokens.spacingVerticalXL,
        '@media screen and (max-width: 480px)': {
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
        }
    },
    resultCardContentWrapper: {
        ...shorthands.padding(tokens.spacingVerticalS),
        cursor: 'pointer'
    },
    resultCardAddress: {
        marginLeft: '35px'
    },
    overnightShipping: {
        marginTop: tokens.spacingVerticalXL,
        fontWeight: tokens.fontWeightBold
    },
    overnightCheckbox: {
        marginLeft: '-7px',
        marginTop: tokens.spacingVerticalS,
        display: 'flex',
        justifyContent: 'space-between'
    },
    loadingSkeleton: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: tokens.spacingVerticalS,
        ...shorthands.padding(tokens.spacingVerticalS)
    },
    radioButton: {
        fontWeight: tokens.fontWeightBold
    },
    showMoreButton: {
        color: tokens.colorBrandForeground1,
        marginLeft: tokens.spacingHorizontalXL,
        cursor: 'pointer'
    },
    methodCost: {
        alignSelf: 'center',
        ...shorthands.padding(tokens.spacingVerticalS)
    }
});

export default useStoreLocatorStyles;
